module.exports = __webpack_public_path__ + "img/product-27.48a89545.jpg";